<template>
  <el-dropdown-item
      v-if="show"
      class="dropdownItem">
    <div
        @click="onClick">
      {{ (toDownload || {}).displayValue || '' }}
    </div>
  </el-dropdown-item>
</template>

<style scoped>

.dropdownItem {
  padding: 0
}

.dropdownItem >>> div {
  padding-left: 20px;
  padding-right: 20px;
}

</style>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'ToDownload',
  props: {
    pageKey: {
      type: String,
      default: null
    },
    conditions: {
      type: Object,
      default: () => {}
    },
    keyword: {
      type: String,
      default: ''
    },
    isAndSearch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      toDownloads: 'toDownloads'
    }),
    toDownload () {
      return this.toDownloads.find((data) => data.key === this.pageKey)
    },
    show () {
      return ((this.toDownload || {}).funcId) == null || this.$isFunctionShown(this.toDownload.funcId)
    }
  },
  methods: {
    onClick () {
      // キーワードはconditionsのvalueとは別で持っているため設定。また、isAndSearchもいれる
      const keywordConditions = _.get(this.conditions, 'keyword', null)
      if (keywordConditions) {
        keywordConditions.value = this.keyword
        keywordConditions.isAndSearch = this.isAndSearch
      }

      // store に検索条件,ダウンロードキーを保存する
      this.$store.dispatch({
        type: 'set',
        states: {
          'Download/passedConditions': this.conditions,
          'Download/passedTemplateKey': this.toDownload.downloadKey
        }
      })

      // ダウンロード画面へ遷移
      this.$router.push({ path: 'download' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organisms/ToDownload.vue